import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'

import { Footer } from '@/components/organisms/Footer/Footer'

import { Introduction } from '@/components/organisms/Introduction/Introduction'
export default function index () {
  return (
    <>
      <Menu />
      <Introduction />
      <Footer />
    </>
  )
}
